import { z } from 'zod';
import { jArticleLittle } from './article';
import { jCommentList } from './comment';
import { extendSchema, FormatExtension } from './extensions';
import { jObjectBase } from './objectBase';
import { jUserLittle } from './user';
import { jSocialEventView } from './socialEvent';

export type WithExtensions<T extends jObjectBase, K extends Array<keyof typeof extendSchema.shape>> = T & {
    _extend: Pick<z.infer<typeof extendSchema>, K[number]>;
};

export function withExtensionsSchema<T extends z.ZodRawShape, K extends FormatExtension>(
    baseSchema: z.ZodObject<T>,
    keys: K,
) {
    const extendKeysSchema = z.object(
        keys.reduce((acc, key) => {
            acc[key] = extendSchema.shape[key];
            return acc;
        }, {} as Record<FormatExtension[number], z.ZodTypeAny>),
    );

    return baseSchema.extend({
        _extend: extendKeysSchema,
    });
}

/**
 * TODO : Add other extended models here to explicitly restrain their available extensions.
 */
export type ArticleFormatsExtension = Array<'actions' | 'comments' | 'attachments' | 'licensesExtrabot' | 'licenses'>;
export type ArticleWithExtensions<T extends jArticleLittle, K extends ArticleFormatsExtension> = WithExtensions<T, K>;

export type CommentFormatsExtension = Array<'actions' | 'attachments'>;
export type CommentWithExtensions<T extends jCommentList, K extends CommentFormatsExtension> = WithExtensions<T, K>;

export type UserFormatsExtension = Array<'licenses'>;
export type UserWithExtensions<T extends jUserLittle, K extends UserFormatsExtension> = WithExtensions<T, K>;
export type SocialEventWithExtensions<
    T extends jSocialEventView,
    K extends Array<'socialEventRecord'>,
> = WithExtensions<T, K>;
